












































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { User } from '@/models/user';
import { UserCustomer } from '@/models/user-customer';
import { UserSite } from '@/models/user-site';
import { CustomerApi } from '@/api/customer-api';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const userModule = namespace('user');
const customerModule = namespace('customer');
const customerApi = new CustomerApi();

@Component
export default class NavigationBar extends Vue {
    @userModule.Getter('user') public user: User | null;
    @userModule.Getter('isAdmin') public isAdmin: boolean;
    @customerModule.Getter('customers') public customers: Array<Customer>;

    public get selectedCustomer(): Customer | null {
        return this.$store.getters['user/currentCustomer'];
    }
    public set selectedCustomer(value: Customer | null) {
        this.$store.commit('user/setCurrentCustomer', value);
        if (value !== null) {
            const customer = this.$store.getters['user/currentCustomer'] as Customer;
            this.$store.commit('user/setCurrentSite', customer.sites[0] || null);
        }
    }
    public get selectedSite(): Site | null {
        return this.$store.getters['user/currentSite'];
    }
    public set selectedSite(value: Site | null) {
        this.$store.commit('user/setCurrentSite', value);
    }
    public async handleLogout(): Promise<void> {
        await this.$store.dispatch('logout');
    }
}
